import React from "react";
import { connect } from "react-redux";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";

const SpinnerComponent = (props) => {
  const { spinner } = props;
  const rqFetching = useIsFetching();
  const rqMutating = useIsMutating();
  const show = spinner > 0 || rqMutating > 0;
  // const show = spinner > 0 || rqFetching + rqMutating > 0;
  // const show = spinner > 0;

  return (
    <React.Fragment>
      {show && (
        <div id="preloader" className="preloader-spinner">
          <div id="status">
            <div className="spinner">
              <div className="double-bounce1"></div>
              <div className="double-bounce2"></div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default connect((state) => ({ spinner: state.global.spinner }))(
  SpinnerComponent
);
